import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {PrimerComponentHeroSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentHero'
import {PrimerComponentCtaBannerSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCtaBanner'
import {PrimerComponentStaticFootnotesSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentStaticFootnotes'

export const TemplateCategorySchema = buildEntrySchemaFor('newsroomTemplateCategory', {
  fields: z.lazy(() =>
    z.object({
      hero: PrimerComponentHeroSchema,
      ctaBanner: PrimerComponentCtaBannerSchema,
      staticFootnotes: safeOptional(PrimerComponentStaticFootnotesSchema),
    }),
  ),
})

export type CategoryTemplate = z.infer<typeof TemplateCategorySchema>
